import { Download } from "lucide-react";
import Reveal from "./Reveal.jsx";
export const brochureURL =
  "/downloads/karalewich-software-automation-brochure.pdf";
export default function BrochureDownload({ placement = "overview" }) {
  return (
    <section data-analytics-section="brochure-download" className="kw-section kw-brochure-download"
      aria-label="Download the Karalewich brochure"
    >
      <Reveal className="kw-brochure-intro">
        <span className="kw-small-label">TAKE THE OVERVIEW WITH YOU</span>
        <h2>
          A clearer picture.
          <br />
          Ready to share.
        </h2>
        <p>
          Custom software, practical automation, and the way we work. A concise
          guide with examples you can share with your team.
        </p>
        <a
          href={brochureURL}
          download="Karalewich-Software-Automation.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="kw-brochure-link"
          data-analytics={`brochure_${placement}`}
          data-analytics-event="link_click"
        >
          <Download size={18} />
          Download brochure<span>PDF · 6 pages</span>
        </a>
      </Reveal>
      <Reveal className="kw-brochure-preview" delay={100}>
        <a
          href={brochureURL}
          download="Karalewich-Software-Automation.pdf"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Download the Karalewich software and automation brochure"
          data-analytics={`brochure_cover_${placement}`}
          data-analytics-event="link_click"
        >
          <img
            src="/images/brochure-cover.png"
            alt="Cover of the Karalewich custom software and automation brochure"
            width="306"
            height="396"
            loading="lazy"
          />
        </a>
      </Reveal>
    </section>
  );
}
